import React from "react"
// import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import WithLeftBorder from "../WithLeftBorder/WithLeftBorder"
import colors from "../../Constants/colors"

const PYPSidebarItem = ({
  item,
  linkTo,
  clickHandler,
  isSelected,
  textStyle,
  uniqueKey,
  children,
  showUnfilled,
  wrapText = false,
  indent = false
}) => {
  const isSelectedStyle = isSelected && { fontFamily: "Lato-Bold", opacity: 1 }
  const to = linkTo || (item?.title ? `/workshop/${item.title}` : "#")

  const onClick = (event) => {
    if (!linkTo) {
      event.preventDefault()
    }
    if (clickHandler) {
      clickHandler(event)
    }
  }

  return (
    <div
      style={{
        ...styles.itemContainer,
        ...(wrapText ? styles.itemContainerWrap : {})
      }}
      key={uniqueKey}
    >
      <WithLeftBorder
        isSelected={isSelected}
        style={wrapText ? styles.borderWrapperWrap : undefined}
        renderComponent={(props) => (
          <Link
            key={uniqueKey}
            to={to}
            onClick={onClick}
            className="pypSideBarItem"
            style={{
              ...styles.itemTitle,
              ...(wrapText ? styles.itemTitleWrap : {}),
              ...(indent ? styles.itemTitleIndent : {}),
              ...textStyle,
              ...isSelectedStyle
            }}
          >
            {item.title}
          </Link>
        )}
      />
    </div>
  )
}

const styles = {
  itemContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "35px",
    margin: "5px 0px 5px 0px",
    cursor: "pointer"
  },
  itemTitle: {
    color: colors.white,
    fontFamily: "Lato-Regular",
    fontSize: "16px",
    lineHeight: "20px",
    marginLeft: "38px",
    whiteSpace: "nowrap",
    textDecoration: "none"
  },
  itemContainerWrap: {
    alignItems: "flex-start",
    minHeight: "35px",
    margin: "5px 0px 5px 0px",
    width: "100%",
    minWidth: 0
  },
  borderWrapperWrap: {
    width: "100%",
    flex: 1,
    minWidth: 0
  },
  itemTitleWrap: {
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    marginLeft: 0,
    paddingLeft: "38px",
    paddingRight: "15px",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    minWidth: 0
  },
  itemTitleIndent: {
    paddingLeft: "50px"
  }
}

export default PYPSidebarItem
